import React from 'react';
import LaddaButton, { EXPAND_RIGHT } from 'react-ladda';

import 'ladda/dist/ladda-themeless.min.css';

const FormButton = ({ color, loading, disabled, name, className, icon, btnPad }) => {
  return (
    <div className={className}>
      <LaddaButton
        type="submit"
        className={`w-full ${btnPad} ${
          disabled ? ' cursor-not-allowed text-cf-300' : `${color} text-white shadow-cf `
        } rounded btn-ladda`}
        loading={loading}
        disabled={disabled}
        data-style={EXPAND_RIGHT}
      >
        {icon}
        {name}
      </LaddaButton>
    </div>
  );
};

export default FormButton;
